// Firefox has low performance of map.
var CacheMap = /*#__PURE__*/function () {
  function CacheMap() {
    this.maps = void 0;
    this.maps = Object.create(null);
  }
  var _proto = CacheMap.prototype;
  _proto.set = function set(key, value) {
    this.maps[key] = value;
  };
  _proto.get = function get(key) {
    return this.maps[key];
  };
  return CacheMap;
}();
export default CacheMap;